import { useBreakpointDown } from '@nesso/ui/hooks/use-breakpoint-down';

import type { Session } from '@/entities/session';
import {
    CopySessionNote,
    CopySessionNoteIntroDialog,
} from '@/features/session-note/copy-session-note';
import { EditSessionNoteSettings } from '@/features/session-note/edit-session-note-settings';
import { useSheetStore } from '@/shared/stores/sheet-store';

import { SessionDetailsHeaderActionsMenu } from './session-details-header/session-details-header-actions-menu';
import { SessionDetailsHeaderInfo } from './session-details-header/session-details-header-info';

interface Props {
    session: Session;
}

export function SessionDetailsHeader({ session }: Props) {
    const isSm = useBreakpointDown('sm');
    const closeCurrentSheet = useSheetStore((state) => state.closeCurrentSheet);

    return (
        <div className="flex flex-col gap-6 bg-card px-4 sm:pr-6 pt-4 pb-3.5">
            <div className="flex items-center justify-between">
                <SessionDetailsHeaderInfo session={session} onBack={closeCurrentSheet} />
                <div className="flex items-center gap-4">
                    {!isSm && <EditSessionNoteSettings session={session} />}
                    <SessionDetailsHeaderActionsMenu session={session} compact={isSm} />
                </div>
            </div>
            {isSm && (
                <>
                    <div className="flex gap-4">
                        <CopySessionNote sessionId={session.id} className="flex-1" />
                    </div>
                    <CopySessionNoteIntroDialog sessionId={session.id} />
                </>
            )}
        </div>
    );
}
